module.exports = __webpack_public_path__ + "img/logistik_w.d6108502.svg";